import { jsxs as h, jsx as t } from "react/jsx-runtime";
import { clsx as p } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import e from "./roche-headline.module.scss.js";
import { RocheUIHeadlineAppearance as r } from "./roche-headline.types.js";
const H = ({
  overline: i,
  headline: s,
  level: n,
  semanticLevel: a,
  appearance: o = r.DEFAULT,
  children: l,
  slot: m,
  ...c
}) => {
  const d = `h${a || n}`;
  return /* @__PURE__ */ h(
    d,
    {
      slot: m,
      className: p(
        e.headline,
        e[`headline--${n}`],
        o !== r.DEFAULT && e[`headline--${o}`]
      ),
      ...c,
      children: [
        i && /* @__PURE__ */ t("span", { className: e.headline__overline, children: i }),
        s || l
      ]
    }
  );
};
export {
  H as RocheUIHeadline
};
